import { SelectOperation } from '@openx/types/selectableTable.ts';
import type { BaseRow } from '@openx/types/tableHelpers.ts';

import { isInArray } from './isInArray.ts';

type ApplySelectionChangeArgs<RowT> = {
  previouslySelectedItems: RowT[];
  changeItems: RowT[];
  itemsComparer: (a: RowT, b: RowT) => boolean;
  operation: SelectOperation;
};

export function applySelectionChange<RowT extends BaseRow>({
  changeItems,
  itemsComparer,
  operation,
  previouslySelectedItems,
}: ApplySelectionChangeArgs<RowT>): RowT[] {
  if (operation === SelectOperation.SELECT) {
    const itemsToSelect = changeItems.filter(item => !isInArray(previouslySelectedItems, item, itemsComparer));
    return [...previouslySelectedItems, ...itemsToSelect];
  }

  return previouslySelectedItems.filter(item => !isInArray(changeItems, item, itemsComparer));
}
